import { core, type Json } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

export type FabricStorageGetStorageApi = <T extends Json>(
  key: string
) => Promise<T>;

/**
 * 从本地缓存中异步获取指定 key 的内容
 * @param key
 * @returns Promise<T extends Json>
 */
export const getStorage: FabricStorageGetStorageApi = <T extends Json>(
  key: string
) => {
  return new Promise<T>((resolve, reject) => {
    core.call<'fabric_storage.getStorage', string, string>(
      'fabric_storage.getStorage',
      key,
      (result) => {
        const fabricErrors = filterFabricErrors(
          result.code,
          result.message,
          result.data
        );
        if (fabricErrors) {
          reject(fabricErrors);
        } else {
          resolve(JSON.parse(result.data));
        }
      }
    );
  });
};
